"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DASHBOARD_MODULE = void 0;
const DASHBOARD_MODULE = exports.DASHBOARD_MODULE = 'dashboard-section';
//# sourceMappingURL=constants.js.map